module.exports = __webpack_public_path__ + "img/logo_other.04801fd6.png";